import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';


import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {

  group: any;
  groups: any;
  id?: number;
  view: any;
  sort = 'name';

  private readonly VIEW_MODE_KEY = 'groups_view_mode';

  viewMode: 'table' | 'cards' = (localStorage.getItem('groups_view_mode') as 'table' | 'cards') || 'table';

  readonly WORKERS_PREVIEW_COUNT = 10;

  expandedWorkers = new Set<number>();
  expandedMonitors = new Set<number>();

  formGroup = new FormGroup ({
    search: new FormControl('',[])
  });

  nameFormGroup = new FormGroup ({
    name: new FormControl('',[Validators.required])
  });

  submitted = false;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  get f(): { [key: string]: AbstractControl } {
    return this.nameFormGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getGroups();

  }

  setViewMode(mode: 'table' | 'cards'): void {
    this.viewMode = mode;
    localStorage.setItem(this.VIEW_MODE_KEY, mode);
  }

  get hasAnyMonitors(): boolean {
    return this.groups?.some((g: any) => this.toNameArray(g.monitor_names).length > 0) ?? false;
  }

  getGroups(){

    let filter = {
      sort: this.sort,
      search: this.formGroup.value.search,
      page: this.pagination.page,
      'expand': 'alert_loop_name,alert_loop_oo_name'
    }

    //console.log('filter', filter);

    this.okService.get("groups",filter)
    .subscribe((data) => {

      this.groups = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

      //console.log("getGroups", data);

    });

  }

  submitForm(){
    //console.log("submitForm()");

    if(this.submitted){
      Object.keys(this.nameFormGroup.controls).forEach(key => {
        this.nameFormGroup.get(key)?.setErrors({ invalid: null });
        this.nameFormGroup.get(key)?.updateValueAndValidity();
      });
    }

    this.submitted = true;

    if (this.nameFormGroup.valid) {
      let values = this.nameFormGroup.value

      this.okService.post("groups",values)
      .subscribe({
          next: (data) => {
            this.group = data.body;

            //console.log("nameFormGroup submit", this.group);

            let id = this.group.id

            this.router.navigateByUrl("/mgmt/group/"+id);

          },
          error: (e) => {

            //console.log("Setup the error",Array.isArray(e));
            //console.log(e);

            if(Array.isArray(e)){
              let self = this;

              //console.log("Setup the error",e);

              // Use of _.forEach() method
              _.forEach(e, function(error:any) {
                //console.log(error);
                self.nameFormGroup.get(error.field)?.setErrors({ invalid: error.message });


                //console.log(error.field,error.message);

              });
            }else{
              this.okService.setAlert(e,"warning")
            }


          },
          complete: () => {
            //console.info('complete');
          }
      });
    }

  }

  changePage(){
    this.getGroups();
  }

  updateFilter(){
    if(this.formGroup.valid){
      this.getGroups();
    }
  }

  countWorkers(workers: any){
    return workers.length;
  }

  toNameArray(names: any): string[] {
    if (!names) { return []; }
    if (Array.isArray(names)) { return names as string[]; }
    return String(names).split(',').map((n: string) => n.trim()).filter((n: string) => n.length > 0);
  }

  workerPreview(group: any): string[] {
    const all = this.toNameArray(group.worker_names);
    return this.expandedWorkers.has(group.id) ? all : all.slice(0, this.WORKERS_PREVIEW_COUNT);
  }

  workerOverflow(group: any): number {
    const total = this.toNameArray(group.worker_names).length;
    return Math.max(0, total - this.WORKERS_PREVIEW_COUNT);
  }

  toggleWorkers(groupId: number, event: Event): void {
    event.stopPropagation();
    this.expandedWorkers.has(groupId) ? this.expandedWorkers.delete(groupId) : this.expandedWorkers.add(groupId);
  }

  monitorPreview(group: any): string[] {
    const all = this.toNameArray(group.monitor_names);
    return this.expandedMonitors.has(group.id) ? all : all.slice(0, this.WORKERS_PREVIEW_COUNT);
  }

  monitorOverflow(group: any): number {
    const total = this.toNameArray(group.monitor_names).length;
    return Math.max(0, total - this.WORKERS_PREVIEW_COUNT);
  }

  toggleMonitors(groupId: number, event: Event): void {
    event.stopPropagation();
    this.expandedMonitors.has(groupId) ? this.expandedMonitors.delete(groupId) : this.expandedMonitors.add(groupId);
  }

  cancelSearch(){
    this.formGroup.setValue({
      search: ''
    });
    this.updateFilter();

  }
  
  export(){
    this.okService.download("groups/export");
  }
}
